<template>
  <div class="parents-solutions-container">
    <div class="parents-solutions-badge">{{ data.badge }}</div>
    <div class="parents-solutions-title">{{ data.title }}</div>
    <div class="parents-solutions-description">
      {{ data.description }}
    </div>
    <div>
      <table class="parents-solutions-table">
        <thead>
          <td
            v-for="(header, i) in data.table.headers"
            :key="i"
            class="parents-solutions-table-header"
          >
            {{ header }}
          </td>
        </thead>
        <tbody>
          <tr v-for="(row, i) in data.table.body" :key="i">
            <td
              v-for="(cell, x) in row.row"
              :key="x"
              class="parents-solutions-table-body"
              :class="x === 0 ? 'table-first-col' : ''"
            >
              <i
                :class="cell.icon"
                :style="{
                  color: cell.color,
                  fontSize: x === 0 ? '1.5vw' : '1.2vw',
                  marginRight: '0.3vw',
                }"
              ></i>
              {{ cell.text }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="parents-solutions-table-mobile">
        <div v-for="(row, i) in data.table.body" :key="i">
          <div
            v-for="(cell, x) in row.row"
            :key="x"
            class="parents-solutions-table-body d-flex"
            :class="x === 0 ? 'table-first-col' : ''"
          >
            <div class="parents-solutions-table-cell-header" v-if="x > 0">
              {{ data.table.headers[x] }}
            </div>
            <i
              :class="cell.icon"
              :style="{
                color: cell.color,
                fontSize: x === 0 ? '1.5vw' : '1.2vw',
                marginRight: '0.3vw',
              }"
            ></i>
            <div :class="x > 0 ? 'parents-solutions-table-cell-body' : ''">
              {{ cell.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";
import { mapGetters } from "vuex";

SwiperCore.use([Autoplay, Pagination, Navigation]);

export default {
  name: "parentsSolution",
  components: {},
  props: ["data"],
  computed: {
    ...mapGetters(["getTestimonials", "getIndividualSolutions"]),
  },
};
</script>

<style></style>
